//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
export default {
  name: "MatrixRowAdmin",
  // props: ["data", "labels", "cols", "sortable", "show"],
};
